// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HI-z","twoColumnImage":"II-z"};